import * as React from 'react';
import Container from '@mui/material/Container';
import { ButtonBrand, fontBrand, gold } from '../../../../getLPTheme.tsx';
import {Typography,Box,Stack} from "@mui/material";
import AdmUsers from "./userButtonExcelContent.tsx"
import Table from "./userTableContent.tsx"

// Funcion principal

export default function GestionarUsuarios () {
    return (
      <Box>
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: { xs: 1, sm: 1 },
            minWidth: 0,
          }}
        >
          <Stack
            spacing={2}
            useFlexGap
            sx={{
              width: { xs: "100%", sm: "90%" },
              alignItems: "center",
              justifyContent: "center",
              minWidth: 0,
            }}
          >
            <Box>
              <Typography variant="body2" textAlign="center" fontFamily={fontBrand.principal} sx={{color:"white" , fontSize: {sm: '2vw', xs: '5vw'}}}>
                  Gestión de usuarios
              </Typography>
            </Box>
            <Box sx={{ position: "relative", m: 1, width: "100%", minWidth: 0 }}>
              <Table/>
            </Box>
          </Stack>
        </Container>
      </Box>
    );
  }
